export const NET_WORTH_CHART_BASE_CONFIG = {
  chart: {
    type: 'column',
  },
  title: {
    text: '',
  },
  yAxis: {
    min: 0,
    labels: {
      formatter() {
        return `$${(this as any).axis.defaultLabelFormatter.call(this)}`;
      },
    },
    title: {
      enabled: false,
    },
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    headerFormat: '<b>{point.x}</b><br/>',
    pointFormat: `{series.name}: {point.y}<br/>Total: \${point.stackTotal:,.2f}`,
    valuePrefix: '$',
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: false,
      },
    },
  },
};
